import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-blue-100">
      <nav className="mx-auto px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-md group-hover:shadow-lg transition-all duration-300 group-hover:scale-105">
              <span className="text-2xl font-black text-white">R</span>
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-black bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">
                Rummy Games
              </span>
              <span className="text-xs text-gray-600 font-semibold">Premium Gaming Platform</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            <Link
              to="/"
              className={`px-5 py-2.5 text-sm font-bold rounded-lg transition-all duration-300 whitespace-nowrap ${
                isActive('/')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'
              }`}
            >
              Home
            </Link>
            <Link
              to="/games"
              className={`px-5 py-2.5 text-sm font-bold rounded-lg transition-all duration-300 whitespace-nowrap ${
                isActive('/games')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'
              }`}
            >
              All Games
            </Link>
            <Link
              to="/features"
              className={`px-5 py-2.5 text-sm font-bold rounded-lg transition-all duration-300 whitespace-nowrap ${
                isActive('/features')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'
              }`}
            >
              Features
            </Link>
            <Link
              to="/about"
              className={`px-5 py-2.5 text-sm font-bold rounded-lg transition-all duration-300 whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'
              }`}
            >
              About
            </Link>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a
              href="https://d2cnj6metxt8ry.cloudfront.net/777game_9EWBJ5N68FS.apk"
              className="px-6 py-3 bg-blue-600 text-white font-black text-sm rounded-xl hover:bg-blue-700 hover:shadow-lg transition-all duration-300 hover:scale-105 whitespace-nowrap inline-flex items-center space-x-2"
            >
              <span>Download Now</span>
              <i className="ri-download-2-line text-lg"></i>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-blue-600 transition-colors"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-blue-100">
            <div className="flex flex-col space-y-2">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-3 text-sm font-bold rounded-lg transition-all duration-300 ${
                  isActive('/')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-700 hover:bg-blue-50'
                }`}
              >
                Home
              </Link>
              <Link
                to="/games"
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-3 text-sm font-bold rounded-lg transition-all duration-300 ${
                  isActive('/games')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-700 hover:bg-blue-50'
                }`}
              >
                All Games
              </Link>
              <Link
                to="/features"
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-3 text-sm font-bold rounded-lg transition-all duration-300 ${
                  isActive('/features')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-700 hover:bg-blue-50'
                }`}
              >
                Features
              </Link>
              <Link
                to="/about"
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-3 text-sm font-bold rounded-lg transition-all duration-300 ${
                  isActive('/about')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-700 hover:bg-blue-50'
                }`}
              >
                About
              </Link>
              <a
                href="https://d2cnj6metxt8ry.cloudfront.net/777game_9EWBJ5N68FS.apk"
                className="px-4 py-3 bg-blue-600 text-white font-black text-sm rounded-lg text-center hover:bg-blue-700 transition-all duration-300"
              >
                Download Now
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
